/** The access levels a `sql` request can ask for, in the order the request
 * form and the CLI offer them. */
export const CLICKHOUSE_LEVELS = ["read", "write", "admin"] as const;
type ClickHouseLevel = (typeof CLICKHOUSE_LEVELS)[number];

const READ = ["SELECT", "dictGet"] as const;
const WRITE = [
  ...READ,
  "INSERT",
  "ALTER UPDATE",
  "ALTER DELETE",
  "TRUNCATE",
] as const;
const ADMIN = [...WRITE, "CREATE", "DROP", "ALTER", "OPTIMIZE"] as const;

/** The ClickHouse privileges each level grants on the requested object, in the
 * order P0 shows them. Each level holds the one below it.
 *
 * It's the connector's own table (`CLICKHOUSE_LEVEL_PRIVILEGES` in
 * p0-connector-clickhouse), which builds the GRANT statements. P0 reads this
 * copy only to say what a request grants. No level holds `ACCESS MANAGEMENT`,
 * `GRANT OPTION`, `SYSTEM`, `KILL QUERY`, named collections or `SOURCES`. */
export const CLICKHOUSE_LEVEL_PRIVILEGES: Readonly<
  Record<ClickHouseLevel, readonly string[]>
> = { read: READ, write: WRITE, admin: ADMIN };
